import { Button, Form } from 'antd'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { helpStatusT, helpStatus} from '../../../common/enums';
import { translate } from 'react-i18next';
import rules from '../../../common/rules/rules';
import Input from 'antd/lib/input';
import Select from 'antd/lib/select';
import { formatDateTime } from '../../../common/utils/helpers';
import { Link } from 'react-router';
import TextArea from 'antd/lib/input/TextArea';

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

const tailFormItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 7,
  },
};

const { Option } = Select;

@translate()
@Form.create()
 export default class QuestionDetail extends Component {
 
  static propTypes = {
    form: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    question: PropTypes.object,
    token: PropTypes.string,
    onAnswer: PropTypes.func.isRequired
  }

  handleAnswer = e => {
    e.preventDefault()

    const { form,  onAnswer } = this.props
        form.validateFields((err,values) => {
            if(!err){
              let sendValues = {}
              if(values.answer){
                sendValues.answer = values.answer
               
              }
              sendValues.id_status = values.id_status
               
                console.log(sendValues)
                onAnswer(sendValues)
            }
        })
  }


  render(){

    const { question, token, t} = this.props
    const { getFieldDecorator } = this.props.form

    return (
      <div>
         <Form.Item {...formItemLayout} label={t('Meno a priezvisko')}>
          {
            question.AccountId ?
            <Link to={`/admin/accounts/${question.AccountId}/profile`}>{question.name}</Link> :
            <span>{question.name}</span>
          }
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('Dátum a čas otázky')}>
          <span>{formatDateTime(question.date_question)}</span>
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('Otázka')}>
          <span>{question.question}</span>
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('Dátum a čas odpovede')}>
          {
            question.date_answer ?
            <span>{formatDateTime(question.date_answer)}</span> :
            <span>{question.date_answer}</span>
          }   
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('Odpoveď')}>  
        {
          getFieldDecorator('answer', {
            initialValue: question.answer
          })(
            <TextArea rows={5} cols={10} placeholder="Odpoveď"></TextArea> 
          )
        } 
          
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('Stav otázky')}>
          {
            getFieldDecorator('id_status', {
              rules: rules.required,
              initialValue: helpStatus.ZODPOVEDANA
            })(
              <Select size="default" placeholder={helpStatusT.ZODPOVEDANA}>
                {Object.entries(helpStatusT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            )
          }
        
        </Form.Item>
       
        <Form.Item {...formItemLayout} label={t('Email')}>
          <span>{question.email}</span>
        </Form.Item>
        <Form.Item {...tailFormItemLayout} >
          <Button size="default" type="primary" onClick={this.handleAnswer}>
            {t('Odpovedať')}
          </Button>
        </Form.Item>
        
      </div>
    )

  }

}


// WEBPACK FOOTER //
// ./src/features/help-management/components/QuestionDetail.js